<template>
  <b-input-group dir="ltr" class="phone-input">
    <b-form-select class="phone-country" :value="country" :options="countries" @change="onCountry"
      aria-label="رمز الدولة" style="max-width: 130px; flex: 0 0 130px"></b-form-select>
    <b-form-input type="tel" :id="id" :name="id" :value="national" :state="state" :placeholder="placeholder" inputmode="numeric" maxlength="15" dir="ltr"
      @input="onNational"></b-form-input>
  </b-input-group>
</template>

<script>
// Country-code picker + national number. Emits one E.164-style string
// ("+201000000000") through v-model, or "" while the number is empty so
// `required` validators keep working.
const COUNTRIES = [
  { value: '+20', text: '🇪🇬 +20' },
  { value: '+966', text: '🇸🇦 +966' },
  { value: '+971', text: '🇦🇪 +971' },
  { value: '+965', text: '🇰🇼 +965' },
  { value: '+974', text: '🇶🇦 +974' },
  { value: '+962', text: '🇯🇴 +962' },
  { value: '+249', text: '🇸🇩 +249' },
  { value: '+218', text: '🇱🇾 +218' },
  { value: '+1', text: '🇺🇸 +1' },
  { value: '+44', text: '🇬🇧 +44' },
];

// Digits only; drop the trunk "0" people type locally (01000... -> 1000...).
function toE164(code, national) {
  const digits = String(national || '').replace(/\D/g, '').replace(/^0+/, '');
  return digits ? code + digits : '';
}

// Longest first, so a longer code is never shadowed by a shorter prefix.
const CODES = COUNTRIES.map((c) => c.value).sort((a, b) => b.length - a.length);

export default {
  name: 'PhoneInput',
  props: {
    value: { type: String, default: '' },
    id: { type: String, default: undefined },
    state: { type: Boolean, default: null },
    placeholder: { type: String, default: '' },
  },
  data() {
    return { country: '+20', national: '', countries: COUNTRIES };
  },
  watch: {
    // Parent changed the value (form reset, profile loaded): follow it.
    value(val) {
      if (val !== toE164(this.country, this.national)) this.parse(val);
    },
  },
  created() {
    if (this.value) this.parse(this.value);
  },
  methods: {
    parse(val) {
      const code = CODES.find((c) => val.startsWith(c));
      if (code) {
        this.country = code;
        this.national = val.slice(code.length);
      } else {
        // Empty (reset) or a legacy local number such as 01000000000.
        this.country = '+20';
        this.national = val;
      }
    },
    onCountry(code) {
      this.country = code;
      this.$emit('input', toE164(code, this.national));
    },
    onNational(val) {
      this.national = val;
      this.$emit('input', toE164(this.country, val));
    },
  },
};
</script>

<style scoped>
/* The page is RTL (bootstrap-rtl); keep the picker on the left of the number. */
.phone-input {
  direction: ltr;
  flex-direction: row !important;
}
.phone-input >>> .form-control {
  text-align: left;
}
.phone-input >>> .phone-country {
  order: 0;
}
.phone-input >>> input {
  order: 1;
}
</style>
